import React from 'react';
import Icon from '../../../components/AppIcon';

const MaterialGuide = () => {
  const materials = [
    {
      icon: 'Shirt',
      name: '가죽',
      description: '천연 가죽 및 인조 가죽 스니커즈',
      care: '착용으로 생긴 주름·크랙 등 자연적인 변형은 세탁으로 없어지지 않지만, 외부 오염은 세탁 후 깨끗하게 관리됩니다.',
    },
    {
      icon: 'Wind',
      name: '합성성유/기능성 소재',
      description: '통기성 메쉬 소재 운동화',
      care: '나일론, 폴리에스터, 니트 소재는 외부 오염이 세탁 후 깔끔하게 관리됩니다.',
    },
    {
      icon: 'Layers',
      name: '매시/캔버스',
      description: '캔버스 소재 스니커즈',
      care: '외부 손세탁으로 대부분의 일상 오염이말끔하게 정리됩니다.',
    },
    {
      icon: 'Droplet',
      name: '스웨이드/누벅',
      description: '기능성 소재',
      care: '소재 특성상 세탁 난이도가 있어 세탁 전, 난이도 있는 오염은 미리 안내드립니다. 가능한 범위에서 외부 오염은 부드럽게 정리됩니다.',
    },
  ];

  return (
    <div className="rounded-xl bg-card p-6 shadow-lg">
      <h3 className="mb-6 text-xl font-bold text-foreground">소재별 세척 가이드</h3>
      <div className="grid gap-6 sm:grid-cols-2">
        {materials?.map((material, index) => (
          <div
            key={index}
            className="rounded-lg border border-border p-5 transition-all duration-200 hover:border-primary hover:shadow-md"
          >
            <div className="mb-4 flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                <Icon name={material?.icon} size={24} color="var(--color-primary)" />
              </div>
              <div>
                <h4 className="font-semibold text-foreground">{material?.name}</h4>
                <p className="text-xs text-muted-foreground">{material?.description}</p>
              </div>
            </div>
            
            <div className="space-y-2">
              <div className="flex items-start gap-2">
                <Icon name="Droplets" size={16} className="mt-0.5 flex-shrink-0 text-accent" />
                <p className="text-sm text-foreground">{material?.care}</p>
              </div>
              
      
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 rounded-lg border border-warning bg-warning/10 p-4">
        <div className="flex items-start gap-3">
          <Icon name="AlertTriangle" size={20} color="var(--color-warning)" className="mt-0.5 flex-shrink-0" />
          <div>
            <p className="mb-1 text-sm font-semibold text-foreground">특수 소재 주의사항</p>
            <p className="text-sm text-muted-foreground">
              금속, 퍼(fur), 니트·우븐, 글리터, PVC 등 특수 소재는 세탁이 불가하거나 제한될 수 있습니다. 난이도 있는 오염은 세탁 전 미리 안내 후 진행합니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialGuide;